function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { mergeSlot } from '../../utils/slot.js';
import ListenersMixin from '../../mixins/listeners.js';
import RouterLinkMixin from '../../mixins/router-link.js';
import QIcon from '../icon/QIcon.js';
export default Vue.extend({
  name: 'QBreadcrumbsEl',
  mixins: [ListenersMixin, RouterLinkMixin],
  props: {
    label: String,
    icon: String
  },
  computed: {
    iconClass: function iconClass() {
      return 'q-breadcrumbs__el-icon' + (this.label !== void 0 ? ' q-breadcrumbs__el-icon--with-label' : '');
    },
    renderData: function renderData() {
      return _objectSpread(_objectSpread({
        staticClass: 'q-breadcrumbs__el q-link ' + 'flex inline items-center relative-position ' + (this.disable !== true ? 'q-link--focusable' : 'q-breadcrumbs__el--disabled')
      }, this.linkProps), {}, _defineProperty({}, this.hasRouterLink === true ? 'nativeOn' : 'on', _objectSpread({}, this.qListeners)));
    }
  },
  beforeCreate: function beforeCreate() {
    this.fallbackTag = 'span';
  },
  render: function render(h) {
    var child = [];
    this.icon !== void 0 && child.push(h(QIcon, {
      "class": this.iconClass,
      props: {
        name: this.icon
      }
    }));
    this.label !== void 0 && child.push(this.label);
    return h(this.linkTag, this.renderData, mergeSlot(child, this, 'default'));
  }
});